import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { HubHomeComponent } from './hub-home.component';
import { HubCaseStudiesListComponent } from './hub-case-studies-list/hub-case-studies-list.component';
import { HubCaseStudyCardComponent } from './hub-case-studies-list/hub-case-study-card/hub-case-study-card.component';
import { HubContributeListComponent } from './hub-program-list/hub-contribute-list/hub-contribute-list.component';
import { HubPractiseListComponent } from './hub-program-list/hub-practise-list/hub-practise-list.component';
import { HubProgramCardComponent } from './hub-program-list/hub-program-card/hub-program-card.component';
import { HubCommunityListComponent } from './hub-community-list/hub-community-list.component';
import { HubCommunityCardComponent } from './hub-community-list/hub-community-card/hub-community-card.component';

@NgModule({
  declarations: [
    HubHomeComponent,
    HubCaseStudiesListComponent,
    HubCaseStudyCardComponent,
    HubContributeListComponent,
    HubPractiseListComponent,
    HubProgramCardComponent,
    HubCommunityListComponent,
    HubCommunityCardComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class HubHomeModule { }
